import React, { PureComponent } from "react";
import { Helmet } from "react-helmet";

class AnalyticsHomePage extends PureComponent {
  render() {
    return (<div>
      <Helmet title="Analytics | PubNinja - You Publish. The rest we manage" />
      {this.props.children}
    </div>)
  }
}
export default AnalyticsHomePage;